<template>
  <v-form class="remove-mailing">
    <v-layout wrap>
      <v-flex mr-md-0 mr-3>
        <h3 class="font-weight-medium display-30 mb-3 text-righ">
          {{ mainTitle }}
        </h3>
      </v-flex>
    </v-layout>

    <v-card v-if="!openReasons && !frequencyConfirm" flat>
      <v-card-text class="pa-2" xs12 sm12 md12 text-xs-center mt-2>
        <v-layout column justify-start>
          <v-flex v-if="removeMode">
            <Switcher
              :label="switcherLabel"
              @changeSetting="changeMailingPreference"
              :initialVal="allowMailing"
              :disableText="disableMailing"
            />
          </v-flex>

          <v-flex>
            <v-radio-group
              v-model="selection"
              v-for="(item, i) in frequencies"
              :key="i"
              xs4
              hide-details
              class="mt-1"
            >
              <v-radio
                :disabled="!allowMailing"
                :label="item.NameInHebrew"
                :value="item"
                class="display-22 black--text mr-0"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="justify-center">
        <DrBtn
          type-btn="orange_btn_large m-auto"
          :action="confirm"
          :loader="inLoading"
          :btnEnabled="!selection && allowMailing"
        >
          שמור שינויים
        </DrBtn>
      </v-card-actions>
    </v-card>

    <v-card v-if="frequencyConfirm" flat>
      <v-card-text class xs12 sm12 md12 text-xs-center mt-2>
        <v-layout column justify-start>
          <v-flex mb-3>
            <v-layout column>
              <v-flex text-center>
                <v-icon class="icon-like1 display-100 primary--text"></v-icon>
                <h3
                  v-html="
                    t('titles.smartAgent.frequencyConfirmMsg', {
                      email: userEmail,
                      frequency: selection.NameInHebrew,
                    })
                  "
                  class="display-22 text-xs-center"
                ></h3>
              </v-flex>

              <v-flex mt-3></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card v-if="openReasons" flat>
      <v-card-text class xs12 sm12 md12 text-xs-center mt-2>
        <v-layout column>
          <v-flex mb-3>
            <v-layout column justify-center v-show="!showReasonsConfirmMsg">
              <v-flex text-center>
                <v-icon class="icon-like1 display-100 primary--text"></v-icon>
              </v-flex>
              <v-flex mt-3>
                <h3
                  v-html="
                    t('titles.smartAgent.removedMailnigMsg', {
                      email: userEmail,
                    })
                  "
                  class="display-22"
                ></h3>
              </v-flex>
            </v-layout>
            <h3 v-show="showReasonsConfirmMsg">
              {{ t('titles.smartAgent.thankYouText') }}
              <v-icon class="display-48 v-align-middle" color="primary">
                mdi-emoticon-outline
              </v-icon>
            </h3>
          </v-flex>

          <v-flex v-if="!showReasonsConfirmMsg">
            <v-radio-group
              hide-details
              v-model="reason"
              v-for="(item, i) in reasons"
              :key="i"
              :disabled="inLoading"
              xs4
              :class="[i == 1 ? 'd-none' : '']"
              class="mt-0"
            >
              <v-flex class="mr-2 pr-2 pl-2">
                <v-radio
                  :value="item.Code"
                  color="primary"
                  class="ma-0"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <strong :class="[`selected-${i}`]">
                        {{ item.NameInHebrew }}
                      </strong>
                    </div>
                  </template>
                </v-radio>
              </v-flex>

              <v-flex
                v-if="isTheReason(item.Code) && reason == 2"
                text-right
                mr-5
              >
                <p class="display-16 mb-0 mr-9">איזה כיף! המון בהצלחה</p>
                <p class="display-14 mr-1 mr-9 mb-0">בעזרתנו ?</p>
                <v-radio-group
                  v-model="withDrushimHelp_Model"
                  class="mt-0 mr-5"
                  hide-details
                >
                  <div class="d-inline-block">
                    <v-radio :label="'כן'" :value="true"></v-radio>
                  </div>
                  <v-layout
                    wrap
                    class="search-input-wrap"
                    v-show="withDrushimHelp_Model"
                    mr-9
                    my-1
                  >
                    <v-flex md5 sm12 pl-md-6>
                      <v-text-field
                        v-model="companies_Model"
                        :label="'שם חברה'"
                        solo
                        type="text"
                        rounded
                        :required="false"
                        outlined
                        dense
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <div class="d-inline-block">
                    <v-radio :label="'לא'" :value="false" class></v-radio>
                  </div>
                </v-radio-group>
              </v-flex>

              <v-flex v-if="isTheReason(item.Code) && reason == 4" mr-5>
                <p class="display-16 text-right mb-0 mr-9">
                  ואם תקבל אימייל פעם ביום ?
                </p>

                <v-radio-group
                  v-model="changeFrequency_Model"
                  class="mt-0 mr-9"
                  hide-details
                >
                  <div class="d-inline-block">
                    <v-radio :label="'מסכים'" :value="true" class></v-radio>
                  </div>
                  <div class="d-inline-block">
                    <v-radio :label="'לא מסכים'" :value="false" class></v-radio>
                  </div>
                </v-radio-group>
              </v-flex>

              <v-flex v-if="isTheReason(item.Code) && reason == 5" mr-5>
                <v-textarea
                  v-model="otherReasonDescription_Model"
                  outlined
                ></v-textarea>
              </v-flex>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="justify-center" v-if="!showReasonsConfirmMsg">
        <DrBtn
          type-btn="orange_btn_large m-auto"
          :action="sendYourReasone"
          :loader="inLoading"
        >
          שלח
        </DrBtn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { debounce } from 'lodash';
import { mapState, mapGetters } from 'vuex';

import Switcher from '@/components/Wrappers/Switch/Switcher';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { UPDATE_SMART_ALERTS } from '@/lib/api.js';
import drushim_lodash from 'lodash/filter';

const SUB_REASONS = 4;
const NEW_JOB = 2;
const ANOTHER = 5;

export default {
  components: {
    Switcher,
  },
  data() {
    return {
      UPDATE_SMART_ALERTS: `${UPDATE_SMART_ALERTS}`,
      switcherLabel: t('titles.candidates.switcherText'),
      text: t('titles.smartAgent'),
      disableMailing: `בחרת שלא לקבל דיוור`,
      selection: {}, //mailing preference/ or the remove selection
      reason: 1, // reason code for the remove , default value 1 if reason not selected
      removeMode: false,
      openReasons: false,
      specifyReason: false,
      mailingFreqExplain: undefined, // explanation for the remove becouse of the frequency : desired mailing freq code
      textField: '',
      allowMailing: null,
      frequencyConfirm: false,
      inLoading: false,
      showReasonsConfirmMsg: false,
      withDrushimHelp_Model: null,
      changeFrequency_Model: null,
      otherReasonDescription_Model: null,
      companies_Model: null,
      search: '',
      items: [],
      loading: false,
    };
  },
  props: {
    agentCode: {
      type: String,
      default: null,
      required: true,
    },
  },

  mounted() {
    this.querySelections = debounce(this.querySelections, 250);
    this.checkDisplayRemoveMode();
    this.allowMailing = true;

    this.selection = drushim_lodash.filter(this.frequencies, function (o) {
      return o.IsSelected;
    })[0];
  },

  computed: {
    ...mapState({
      frequencies: (state) =>
        state.smartAlertsSettings.removeData.FrequencyPreferencesList,
      texts: (state) => state.smartAlertsSettings.removeData.KeysDictionary,
      reasons: (state) =>
        state.smartAlertsSettings.removeData.RemoveReasonMenu.Menu,
      userEmail: (state) => state.auth.user.UserProfile.Email,
    }),

    ...mapGetters(['removeReasons']),

    allOptions() {
      return [...this.frequencies];
    },

    mainTitle() {
      return this.checkDisplayRemoveMode();
    },

    removeMailing() {
      return this.texts.Keys[1].KeyValue;
    },

    explanations() {
      let res = this.removeReasons(SUB_REASONS);
      res.shift();
      return res;
    },
  },

  methods: {
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.companies.filter((e, i) => {
          return (e.NameInHebrew || '').indexOf(v || '') > -1;
        });
        this.loading = false;
      }, 500);
    },

    changeMailingPreference(val) {
      this.allowMailing = val;
    },

    isTheReason(code) {
      return this.reason == code;
    },

    areSubReasons(code) {
      return this.reason == SUB_REASONS;
    },

    checkDisplayRemoveMode() {
      const query = this.$route.query;

      if (query && query.sra) {
        this.removeMode = true;
        return this.texts.Keys[1].KeyValue.Value;
      } else {
        return this.texts?.Keys[0].KeyValue.Value;
      }
    },
    confirm() {
      if (this.allowMailing) {
        this.sendChangeFrequency();
      } else {
        this.sendRemove();
      }
    },
    sendYourReasone() {
      this.inLoading = true;
      let data = {
        ReasonCode: this.reason,
        WithDrushimHelp: this.withDrushimHelp_Model,
        CompanyName: this.companies_Model,
        CompanyCode: null,
        ChangeFrequency: this.changeFrequency_Model,
        OtherReasonDescription: this.otherReasonDescription_Model,
        AgentCode: this.agentCode,
      };

      try {
        this.$axios
          .post(`${UPDATE_SMART_ALERTS}/logreamovereason`, data)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            setTimeout(() => {
              this.showReasonsConfirmMsg = true;
              this.inLoading = false;
              this.fetchUser();
              if (this.changeFrequency_Model)
                this.$router.push('/personal/smartalertsnotification/');
            }, 2000);
          });
      } catch (e) {
        console.log('failed remove from mailing ', e);
        this.$toast.error(e);
      }
    },

    async sendRemove() {
      this.inLoading = true;
      const data = {
        agentCode: this.agentCode,
      };

      try {
        this.$axios
          .post(`${UPDATE_SMART_ALERTS}/remove`, this.agentCode)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            setTimeout(() => {
              this.openReasons = true;
              this.inLoading = false;
              this.fetchUser();
            }, 1000);
          });
      } catch (e) {
        console.log('failed remove from mailing ', e);
        this.$toast.error(e);
      }
    },

    async sendChangeFrequency() {
      this.inLoading = true;

      const data = {
        Type: this.selection.Code,
        AgentCode: this.agentCode,
      };
      try {
        this.$axios
          .post(`${UPDATE_SMART_ALERTS}/changefrequency`, data)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            setTimeout(() => {
              this.frequencyConfirm = true;
              this.inLoading = false;
              this.fetchUser();
            }, 1000);
          });
      } catch (e) {
        console.log('failed update mailing freq ', e);
        this.$toast.error(e, { icon: 'error' });
      }
    },

    async fetchUser() {
      await this.$auth.fetchUser();
    },
  },

  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    selection(val) {
      if (val === 'AlertSettings_Remove_Text') {
        this.openReasons = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remove-mailing-hdr {
  background: #3e4a54 !important;
  color: #fff !important;
}

.button-align {
  margin-left: 40%;
}

.v-radio.ma-0.theme--light.primary--text >>> .theme--light.v-label {
  color: $primary !important;
}
</style>
